import React, { useContext } from 'react';

import FileDropZone from 'components/shared/FileDropZone';

import Context from '../../context';

const DropZone = () => {
  const context = useContext(Context);

  return (
    <FileDropZone
      placeholder={context.placeholder}
      allowedMimeTypes={context.allowedMimeTypes}
      maxFileSize={context.maxFileSize}
      maxImageWidth={context.maxImageWidth}
      maxImageHeight={context.maxImageHeight}
      onSelectNewFiles={(files) => context.onSelectNewFiles(files)}
      needToShowWarning={context.module === 'document'}
      multiple
      renderFilePropertiesHint={context.renderFilePropertiesHint}
    />
  );
};

export default DropZone;
